/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Box, Button } from '@material-ui/core';
import { FC, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ChannelService } from '../../../services/channel_talk';
import { Appbar } from '../../atoms/Appbar';
import { messages } from './messages';
import { clearedVisitorProfile, hasVisitorProfile, parseSupportContext } from './supportContext';

export const Boot: FC = () => {
  const { search } = useLocation();
  const context = useMemo(() => parseSupportContext(search), [search]);
  const copy = context.appLanguage ? messages[context.appLanguage] : undefined;

  useEffect(() => {
    let active = true;
    ChannelService.boot({
      pluginKey: process.env.REACT_APP_CHANNEL_TALK_PLUGIN_KEY,
      memberId: context.memberId,
      hideDefaultLauncher: true,
      mobileOpenUI: 'newTab',
      zIndex: 1,
      language: context.language,
      ...(context.profile ? { profile: context.profile } : {}),
    }, (error: unknown, user?: { profile?: { [key: string]: unknown } }) => {
      if (!active || error) return;
      // boot.language does not update an existing user's saved language.
      // Ordinary Japanese users keep their profile. Former Visitors clear only
      // our three fields, including when they return on a different browser.
      if (context.profile || hasVisitorProfile(user && user.profile)) {
        ChannelService.updateUser({
          language: context.language,
          profile: context.profile || clearedVisitorProfile,
        }, (updateError: unknown) => {
          if (!active) return;
          if (updateError) console.error('Channel Talk support context update failed');
          ChannelService.show(context.memberId);
        });
      } else {
        ChannelService.show(context.memberId);
      }
    });
    return () => {
      active = false;
      ChannelService.shutdown();
    };
  }, [context]);

  return (
    <div lang={context.appLanguage || 'ja'}>
      <Appbar title={copy ? copy.title : 'お問い合わせ'} />
      <Box alignContent="center" margin="150px 20px" textAlign="center">
        <p>{copy ? copy.body : <span>チャット画面が自動開かない場合は、<br />以下のボタンを押してください</span>}</p>
        <Button
          css={{ padding: '10px 24px', width: '100%', maxWidth: 300, margin: '30px auto', fontWeight: 'bold' }}
          variant="contained"
          size="large"
          color="primary"
          style={{ borderRadius: '24px' }}
          onClick={() => ChannelService.show(context.memberId)}
        >
          {copy ? copy.button : 'チャット'}
        </Button>
      </Box>
    </div>
  );
};
